import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ErrorAlertComponent } from "../shared/error-alert/error-alert.component"
import { LoadingService } from '../../services/general/loading.service';
import { GetOtpService } from '../../services/get-otp/get-otp.service';
import { GetOtpRequest, GetOtpResponse } from '../../interfaces/get-otp.interface';
import { ReactiveFormsModule, FormsModule, NgForm } from '@angular/forms';
import { ConfirmationModalComponent } from '../shared/confirmation-modal/confirmation-modal.component';
import { LogTackingService } from '../../services/logs/log-tacking.service'
import { LogsTrackingRequest, LogsTrackingResponse } from '../../interfaces/logs_tracking.interface.';
import { PageHeaderComponent } from '../shared/page-header/page-header.component';


@Component({
  selector: 'app-get-otp',
  standalone: true,
  imports: [CommonModule, FormsModule, ErrorAlertComponent, ReactiveFormsModule, ConfirmationModalComponent, PageHeaderComponent],
  templateUrl: './get-otp.component.html',
  styleUrl: './get-otp.component.css'
})
export class GetOtpComponent {

  constructor(
    private _loadingService: LoadingService,
    private _logsService: LogTackingService,
    private _getOtpService : GetOtpService
  ){

  }

  getOtpRequest: GetOtpRequest = {
    email: '',
    phone_number: '+57'
  }
  getOtpResponse: GetOtpResponse = {
    Code: ''
  }
  isEmailValid: boolean = true; // Indica si el correo es válido
  emailError: string = ''; // Mensaje de error dinámico
  errorMessage: string = '';
  showAlertError: boolean = false;
  isModalVisible: boolean = false
  consultType : string =  ''
  consultTypes = ['Correo', 'Celular']
  token = localStorage.getItem('authToken') ?? ''
  otpConsulText : string = 'El codigo OTP es'
  log_info: LogsTrackingRequest = {
    email: localStorage.getItem('userName') ?? '',
    action: 'Obtener otp',
    details: '',
    ip_address: localStorage.getItem('ip') ?? ''
  }

  onSubmit(form: NgForm): void {
    this._loadingService.setLoading(true)
    this._getOtpService.getOtp(this.token,this.getOtpRequest).subscribe(
      (response: GetOtpResponse) => {
        this._loadingService.setLoading(false)
        this.isModalVisible = true
        this.getOtpResponse = response
        this.otpConsulText = `El codigo es ${response.Code}`
        if(this.getOtpRequest.email) this.log_info.details = `Success: Usuario obtuvo otp para el correo ${this.getOtpRequest.email}`
        else this.log_info.details = `Success: Usuario obtuvo otp para el numero ${this.getOtpRequest.phone_number}`
        this.createTrackingLog()
      },
      (error) => {
        if(error.error.error) this.errorMessage = error.error.error
        this.log_info.details = `Error: ${this.errorMessage}`
        this.showErrorComponent(form)
      }
    );
    // this.isModalVisible = true
  }
  showErrorComponent(form: NgForm) {
    this._loadingService.setLoading(false);
    this.createTrackingLog()
    this.showAlertError = true
    setTimeout(() => {
      this.showAlertError = false;
      this.cancel(form)
    }, 6000);
  }

  cancel(form: NgForm) {
    form.resetForm();
  }

  onConfirm(form: NgForm) {
    this._loadingService.setLoading(true)
    this.isModalVisible = false;
  }

  onCancel() {
    this.isModalVisible = false;
  }

  validateEmail(): void {
    const email = this.getOtpRequest.email;
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; 

    if (!email) {
      this.isEmailValid = false;
      this.emailError = 'Este campo es requerido!';
    } else if (!emailPattern.test(email)) {
      this.isEmailValid = false;
      this.emailError = 'Por favor ingresa un correo válido!';
    } else {
      this.isEmailValid = true;
      this.emailError = '';
    }
  }

  createTrackingLog() {
    this._logsService.generateTrackingLog(this.log_info).subscribe({
      next: (response: LogsTrackingResponse) => { },
      error: (error) => {
        console.log(error);
      }
    });
  }

}
